import { trans } from "./../helper/trans";
import { dimmer } from "./../helper/dimmer";
import { humanDate } from "./../helper/humanDate";
import { notify } from "./../helper/notify";
import { request } from "./../helper/request";
import { sendEmail } from "./../helper/sendEmail";
import { playButton } from "./../helper/playButton";
import { fetchUpdatedThumbs } from "./../helper/fetchUpdatedThumbs";
import { cModal } from "./../helper/modal";
import { v4 as uuid } from "uuid";
import { urlId, lang, status, languages, metaFields, placeholder } from "./../app";
// some imports from our global scope

let orderWrapper = $("#orders_list_wrapper");
let formWrapper = $("#orders_form_wrapper");
let userLevel, admin, author;

window.renderContent = async user => {
	userLevel = user.userLevel;
	admin = userLevel === "admin";
	author = `${user.gacUser.firstname} ${user.gacUser.lastname}`;

	if (urlId) {
		// this is probably an order
		// lookup based on an order id

		try {
			const response = await getOrder(urlId);
			if (response.length) {
				presentOrders(response);
				// no orders found message
			} else {
				$("#order_error").remove();
				orderWrapper.html(`<div class="uk-margin-bottom" id="order_error">
                    ${trans("No order with that ID was found.")}
                    </div>`);
				buildUserForm();
			}
		} catch (err) {
			console.error("Error fetching order:", err);
			notify(trans("error"), "danger");
		}
	} else {
		if (userLevel != "admin") {
			// present order ID form

			buildUserForm();
		} else {
			// admins see all new orders

			try {
				const response = await getNewOrders();
				buildUserForm();
				presentOrders(response);
			} catch (err) {
				console.error("error fetching orders:", err);
				notify(err, "danger");
			}
		}
	}
};
// end renderContent function

const buildUserForm = () => {
	formWrapper.html(`<form class="uk-margin-large-bottom" uk-grid id="order_lookup_form" enctype="multipart/form-data" autocomplete="off">
        <div class="field uk-width-1-1 uk-flex uk-flex-between ${admin ? "uk-width-1-2@s" : ""}">
            <div class="uk-width-expand uk-margin-small-right">
                <label for="id">${trans("Order ID")}*</label>
                <input name="id" type="text" class="uk-input"/>
                <div class="uk-text-small uk-margin-bottom">*${trans("Find your Order ID in the confirmation email sent to you by Gulfstream.")}</div>
            </div>            
        </div>
        ${
			admin
				? `<div class="field uk-width-1-1 uk-width-1-2@s uk-flex uk-flex-between">
                    <div class="uk-width-expand uk-margin-small-right">
                        <label for="email">Whole or partial email</label>
                        <input name="email" type="text" class="uk-input"/>
                        <div class="uk-text-small uk-margin-bottom">Find all orders whose email matches or partially matches provided term. <span class="bold">TIP:</span> "@" finds all orders, but might take some time.</div>
                    </div>                  
                </div>`
				: ""
		}
		<div class="uk-width-1-1 uk-margin-remove">
                <button id="order_button" class="uk-button uk-button-primary">${trans("Submit")}</button>
            </div>
    </form>`);

	let id_input = formWrapper.find("input[name='id']");
	let email_input = formWrapper.find("input[name='email']");
	id_input.on("input", function () {
		if (email_input.length) {
			email_input.val("");
		}
		$(this).parents(".field").removeClass("error");
	});
	email_input.on("input", function () {
		id_input.val("");
		$(this).parents(".field").removeClass("error");
	});
	// on input, clear errors and empty sibling input

	$("#order_button").on("click", async function (e) {
		e.preventDefault();
		const form = $("#orders_form_wrapper");
		let idVal = id_input.val().trim();
		let emailVal = admin ? email_input.val().trim() : "";

		if (!idVal && !admin) {
			id_input.parents(".field").addClass("error");
		} else if (idVal) {
			try {
				form.append(dimmer);
				const response = await getOrder(idVal, false);
				form.find(".dimmer").remove();
				if (response.length) {
					presentOrders(response);
				} else {
					// no orders found message
					$("#order_error").remove();
					orderWrapper.html(`<div class="uk-margin-bottom" id="order_error">
                    ${trans("No order with that ID was found.")}
                </div>`);
					buildUserForm();
				}
			} catch (err) {
				form.find(".dimmer").remove();
				console.error("Error fetching order:", err);
				notify(trans("error"), "danger");
			}
		} else if (admin && !emailVal) {
			id_input.parents(".field").addClass("error");
			email_input.parents(".field").addClass("error");
		} else if (emailVal) {
			try {
				form.append(dimmer);
				const response = await getOrder(emailVal, true); // true means this is an email lookup
				form.find(".dimmer").remove();
				if (response.length) {
					presentOrders(response, true);
				} else {
					// no orders found message

					$(".asset_container").remove();
					$("#order_error").remove();
					orderWrapper.html(`<div class="uk-margin-bottom" id="order_error">
                    No orders from an email address matching "${emailVal}" were found.
                </div>`);
					buildUserForm();
				}
			} catch (err) {
				form.find(".dimmer").remove();
				console.error("Error fetching order:", err);
				notify(trans("error"), "danger");
			}
		}
	});
	// order id- or email-based (for admins)
	// look-up form submit handler
};
// end buildUserForm function

const getOrder = (term, isEmail) => {
	return new Promise(async (resolve, reject) => {
		const params = {
			datatype: "order",
			reqId: status === "admin" ? "c6148d32-343e-4918-b0fb-53982f7412e0" : "644bff17-8cd7-46ea-b103-8d98ac019eaa"
		};
		if (isEmail) {
			// term is an email, not an ID

			if (term != "@") {
				params.namesAdd = {
					"#email": "email"
				};
				params.valuesAdd = {
					":email": term
				};
				params.filter = "contains( #email, :email)";
			}
		} else {
			// fetching by ID

			params.keyAdd = "AND #id = :id";
			params.namesAdd = {
				"#id": "id"
			};
			params.valuesAdd = {
				":id": term
			};
		}
		try {
			const response = await request(params);
			resolve(response);
		} catch (err) {
			reject(err);
		}
	});
};
// end getOrder function

const getNewOrders = () => {
	return new Promise(async (resolve, reject) => {
		try {
			const response = await request({
				reqId: "c6148d32-343e-4918-b0fb-53982f7412e0",
				datatype: "order",
				filter: "#status = :new",
				namesAdd: {
					"#status": "status"
				},
				valuesAdd: {
					":new": "new"
				}
			});
			resolve(response);
		} catch (err) {
			reject(err);
		}
	});
};
// end getNewOrders function

const isExpired = url => {
	const expires = new URLSearchParams(url.substring(url.indexOf("?"))).get("sig.expires");
	if (expires && parseInt(expires) * 1000 <= new Date().getTime()) {
		return true;
	}
	return false;
};
// end isExpired function

const updateThumbs = (orders, index = 0) => {
	return new Promise(async (resolve, reject) => {
		if (orders && orders.length) {
			const assetWrappers = $(`[data-id='${orders[index].id}']`).find(".asset_wrapper");
			let parent = $(".asset_group").eq(index).css("position", "relative").append(dimmer(1.5));
			let order = orders[index];
			let updates = [];
			// reset asset array for each order

			if (order.assets && order.assets.length) {
				order.assets.forEach((asset, assetIndex) => {
					if (isExpired(asset.thumb)) {
						updates.push({
							index: assetIndex,
							uuid: asset.uuid
						});
					}
				});
				if (updates.length) {
					try {
						updates = fetchUpdatedThumbs(updates, 0, assetWrappers);
						// by sending in assetWrappers, fetchUpdatedThumbs
						// itself will update image src attributes as well as
						// return updated "updates" objects

						if (index === orders.length - 1) {
							parent.find(".dimmer").remove();
							resolve(orders);
						} else {
							parent.find(".dimmer").remove();
							index++;
							resolve(updateThumbs(orders, index));
						}
					} catch (err) {
						parent.find(".dimmer").remove();
						reject(err);
					}
				} else {
					if (index === orders.length - 1) {
						parent.find(".dimmer").remove();
						resolve(orders);
					} else {
						parent.find(".dimmer").remove();
						index++;
						resolve(updateThumbs(orders, index));
					}
				}
			} else {
				if (index === orders.length - 1) {
					parent.find(".dimmer").remove();
					resolve(orders);
				} else {
					parent.find(".dimmer").remove();
					index++;
					resolve(updateThumbs(orders, index));
				}
			}
		} else {
			resolve(orders);
		}
	});
};
// end updateThumbs function

const presentOrders = async (orders, isEmail) => {
	if (admin) {
		let compareKey = isEmail ? "time" : "duedate";
		let ltRetVal = isEmail ? 1 : -1;
		let gtRetVal = isEmail ? -1 : 1;
		orders = orders.sort((a, b) => {
			if (a[compareKey] < b[compareKey]) {
				return ltRetVal;
			} else if (a[compareKey] > b[compareKey]) {
				return gtRetVal;
			}
			return 0;
		});
	}
	// admins need orders in asc duedate order unless
	// orders are from email search, in which case they
	// must be in desc request time order

	orderWrapper.html(`<div>
	    ${orders
			.map((order, index) => {
				let processed = order.status === "processed";
				let expired = processed ? new Date().getTime() > order.expires : false;

				return `${index > 0 ? `<hr class="separator top bottom"/>` : ""}<div data-id="${order.id}" class="asset_container uk-margin-bottom">
	            <div class="asset_details uk-margin-large-bottom">${admin ? `<div class="bold order_index uk-margin-large-top uk-margin-large-bottom">Request ${index + 1} of ${orders.length}</div>` : ""}
	                <div class="order_id">${trans("ID")}: ${order.id}</div>
	                <div class="uk-overflow-auto">
	                    <table class="detail_table uk-table-justify uk-table uk-table-large">
	                        <thead>
	                            <th ${admin ? `style="width: 100px;"` : `style="width: 120px;"`}>${trans("Status")}</th>
	                            ${admin ? `<th>Requestor details</th>` : ""}
	                            <th class="uk-table-expand">${trans("Usage")}</th>
	                            <th class="uk-table-expand">${trans("Requested")}</th>
	                            <th class="uk-table-expand">${trans("Wanted By")}</th>
	                            <th class="uk-table-expand">${expired ? trans("Expired") : trans("Expires")}</th>
	                        </thead>
	                        <tbody>
	                            <tr>
	                                <td><div ${admin ? `class="uk-text-center"` : ""}><span class="status_label${admin ? (!expired ? (order.status === "processed" ? " processed" : " processing") : " expired") : ""}">${!expired ? (processed ? (admin ? `<span uk-icon="icon: happy; ratio: 4"></span>` : trans("processed")) : admin ? `<span uk-icon="icon: bell; ratio: 4"></span>` : trans("processing")) : admin ? `<span uk-icon="icon: clock; ratio: 4"></span>` : trans("expired")}</span>${admin && order.processedBy ? `<div class="uk-text-small" style="line-height: 150%;">Processed by <span class="bold">${order.processedBy}</span> on ${humanDate(order.processedTime, true, " at ")}</div>` : ""}</div>${admin ? `<div class="uk-text-center uk-margin-small-top"><span class="delete_order_button pointer text-utility-red" uk-icon="icon: trash; ratio: 2"></span></div>` : ""}</td>
	                                ${
										admin
											? `<td><span class="bold">Name:</span> ${order.firstname} ${order.lastname} (${order.website ? `<a class="underline" href="${order.website}" target="_blank">${order.company}</a>` : order.company})<br/>
	                                        <span class="bold">Location:</span> ${order.city}, ${order.country}<br/>
	                                        <span class="bold">Request language:</span> ${languages[order.lang]}<br/>
	                                        <span class="bold">Email:</span> <a href="mailto:${order.email}">${order.email}</a><br/>
	                                        <span class="bold">Phone:</span> <a href="tel:${order.phone}">${order.phone}</a><br/>
	                                        <span class="bold">Signed terms:</span> ${order.hasOwnProperty("termsAgree") ? (order.termsAgree ? "Yes" : "No") : "N/A"}${order.hasOwnProperty("termsAgree") ? ` (eSignature: ${order.eSig})` : ""}</td>`
											: ""
									}
	                                <td>${order.use}</td>
	                                <td>${humanDate(order.time, true, ", ")}${admin ? `<div class="uk-text-small uk-margin-small-top">Purges from database on <span class="bold">${humanDate(order.ttl * 1000, true, " at ")}</span></div>` : ""}</td>
	                                <td>${humanDate(order.duedate, true, ", ")}</td>
	                                <td>${order.expires ? humanDate(order.expires, true, ", ") : admin ? "Set when approved" : ""}</td>
	                            </tr>
	                        </tbody>
	                    </table>
	                </div>
	                ${!admin && order.note ? `<div class="uk-margin-small"><span>${trans("Message")}:</span> ${order.note}</div>` : ""}
	                </div>
	                <div class="requested_assets"><span>${trans("Requested Assets")}</span></div>
	                <div class="asset_group">
	                    <div class="uk-grid-small uk-grid-row-large" uk-grid>
	                ${order.assets
						.map(
							(asset, asset_index) => `<div class="asset_wrapper uk-width-1-1 uk-width-1-4@s">
	                            <div class="categories uk-text-small">${trans(metaFields.find(item => Object.keys(item)[0] === asset.locator.field)[asset.locator.field])} > ${asset.locator.value}</div>
	                            <div uk-tooltip="title:${asset.name}" class="asset_name">${asset.name}</div>
	                            <div class="asset_thumb_wrapper uk-cover-container" ${asset.type.toLowerCase() === "video" ? `style="position: relative"` : ""}>
	                                <img uk-cover data-id="${asset.uuid}" src="${isExpired(asset.thumb) ? placeholder : asset.thumb}">
	                                ${asset.type.toLowerCase() === "video" ? playButton() : ""}
	                            </div>
	                            ${
									!admin
										? order.status === "processed" && !expired
											? `<div class="metadata"><span>${trans("Status")}:</span> ${trans(asset.status)}${asset.note ? `<br/>${trans("message")}: ${asset.note}` : ""}${
													asset.download
														? `<br/><div class="asset_download_wrapper">
	                                <span class="download_link underline pointer" data-order=${index} data-asset=${asset_index}>${trans("Download")}</span>
	                            </div>`
														: ""
											  }</div>`
											: ""
										: `<div class="field">
	                                <label><input class="uk-radio" type="radio" value="approved" name="asset_status_${index}-${asset_index}" ${asset.status && asset.status === "approved" ? "checked" : ""}> Approved</label>
	                                <label class="uk-margin-small-left"><input class="uk-radio" type="radio" value="denied" name="asset_status_${index}-${asset_index}" ${!asset.status || (asset.status && asset.status != "approved") ? "checked" : ""}> Denied</label>
	                            </div>
	                            <div class="field">
	                                <label class="uk-text-small">Asset-specific note (optional)</label>
	                                <input type="text" name="asset_note_${index}-${asset_index}" value="${asset.note ? asset.note : ""}" class="uk-input">
	                            </div>`
								}
	                        </div>`
						)
						.join("")}
	                </div>
	                </div>
	                ${
						admin
							? `<label class="uk-width-1-1">Note to requestor (optional)</label>
							<form uk-grid class="uk-grid-small uk-margin-top">
								<div class="field uk-width-1-1 uk-width-1-5@s">
									<label class="uk-text-small uk-width-1-1">If denying, choose a reason</label>
									<select data-index="${index}" name="denial" class="uk-select">
										<option value="">Select denial reason</option>
										<option value="Hello,\nThe images on gulfstreamnews.com are intended for members of the media and require media-specific terms of use. To inquire about Gulfstream images for commercial use, please email trademark@gulfstream.com">Commercial use</option>
										<option value="Thank you for your interest in Gulfstream.\nUnfortunately, the images on gulfstreamnews.com are reserved for media use only.">Personal use</option>
									</select>
								</div>
								<div class="field uk-width-1-1 uk-width-4-5@s">
									<label class="uk-text-small">Explanatory text</label>
		                        	<textarea class="uk-textarea uk-width-expand" rows="3" name="order_note_${index}">${order.note ? order.note : ""}</textarea>
								</div>
		                	</form>
			                <button class="order_submit uk-margin-top uk-button uk-button-primary" data-index="${index}">Process Request</button>`
							: ""
					}
	                </div>`;
			})
			.join("")}`);
	// place order details on the page

	$("select[name='denial']")
		.select2({
			minimumResultsForSearch: Infinity
			// width: "20%"
		})
		.on("change", function () {
			$(`textarea[name='order_note_${$(this).attr("data-index")}']`)
				.val($(this).val())
				.css({
					height: "auto"
				});
		});
	// initialize select input

	$(".download_link")
		.off("click")
		.on("click", function () {
			try {
				const link = $("<a>").attr("href", orders[$(this).attr("data-order")].assets[$(this).attr("data-asset")].download).css("opacity", 0);
				$("body").append(link);
				link[0].click();
				link.remove();
			} catch (err) {
				console.error("Error downloading:", err);
				notify(trans("error"), "danger");
			}
		});

	try {
		await updateThumbs(orders);
		// this fn checks to see if img links are expired
		// and updates them if they are
	} catch (err) {
		notify(trans("error"), "danger");
		console.error("Error updating order thumbnails:", err);
	}

	if (admin) {
		$(".order_submit")
			.off("click")
			.on("click", async function (e) {
				// admin submit handler

				let now = new Date().getTime();
				let assetGroup = $(this).siblings(".asset_group").css("position", "relative").append(dimmer());
				e.preventDefault();
				let index = $(this).attr("data-index");
				let order = orders.find(item => item.id === $(this).parents(".asset_container").attr("data-id"));
				order.status = "processed";
				order.processedBy = author;
				order.processedTime = now;
				order.expires = now + 1000 * 60 * 60 * 24 * 14;
				// expiration is in two weeks

				order.note = $(`[name='order_note_${index}'`).val();
				// global note added, if included,

				let approved = false;
				order.assets.forEach((asset, assetIndex) => {
					asset.status = $(`[name='asset_status_${index}-${assetIndex}']:checked`).val();
					asset.note = $(`[name='asset_note_${index}-${assetIndex}']`).val();
					if (asset.status === "approved") {
						approved = true;
					} else {
						delete asset.download;
					}
					// if any assets are approved, approved flag is set to true
				});
				// match up order asset status and note vals to
				// dom inputs

				if (approved) {
					try {
						order.assets = await getLinks(order.assets);
					} catch (err) {
						console.error("Error fetching asset links:", err);
						notify("There was an error getting asset links", "danger");
					}
				}
				let params = {
					reqId: "4b9d14f5-1255-4f03-8b6a-da2363fe25ee",
					data: [
						{
							PutRequest: {
								Item: order
							}
						}
					]
				};
				try {
					await request(params, assetGroup);
					try {
						const notifyResponse = await notifyUser(order, approved, assetGroup);
						notify("Order has been processed");
						assetGroup.parents(".asset_container").addClass("processed").find(".status_label").text("Processed").removeClass("processing").addClass("processed");
						// dim order in DOM
					} catch (err) {
						notify("There was an error notifying the user", "danger");
						console.error("Error notifying user:", err);
						assetGroup.find(".dimmer").remove();
					}
					// notify user about order update
				} catch (err) {
					console.error("Error saving order:", err);
					notify("There was an error saving this order", "danger");
				}
			});
		// end order_submit click handler

		$(".delete_order_button")
			.off("click")
			.on("click", async function () {
				// delete order button click handler

				const thisId = $(this).parents(".asset_container").attr("data-id");
				const delOrder = orders.find(item => item.id === thisId);
				try {
					await cModal(`<h4>Are you sure?</h4>
				<p>You are about to delete a request from <strong>${delOrder.firstname} ${delOrder.lastname}</strong> of <strong>${delOrder.company}</strong> made on <strong>${humanDate(delOrder.time, true, " at ")}</strong> for the following stated purpose:</p>
				<p>${delOrder.use}</p>`);
					try {
						await request({
							reqId: "f7ace6c3-dc2b-47f4-9f08-b890a61739ea",
							id: thisId,
							datatype: "order"
						});
						orders = orders.filter(item => item.id != thisId);
						notify(`Successfully deleted order`, "success");
						presentOrders(orders, isEmail);
					} catch (err) {
						throw `Error deleting order: ${err}`;
					}
				} catch (err) {
					if (err) {
						console.error(err);
					} else {
						notify("Order deletion canceled");
					}
				}
			});
	}
};
// end presentOrders function

const getLinks = (assets, assetIndex = 0) => {
	// assets is a ref to the order assets arrayindex

	return new Promise(async (resolve, reject) => {
		if (assets[assetIndex].status === "approved") {
			try {
				const response = await request({
					reqId: "e2d62eb2-ab96-416c-830c-78a8924fec14",
					id: assets[assetIndex].uuid,
					expand: "metadata,embeds"
				});
				let asset = response;
				let type = asset.metadata.fields.newsroomAssetType[0].toLowerCase();
				switch (type) {
					case "video":
						assets[assetIndex].download = asset.embeds ? (asset.embeds.original && asset.embeds.original.url ? asset.embeds.original.url : asset.embeds.video_player_with_download && asset.embeds.video_player_with_download.url ? asset.embeds.video_player_with_download.url : asset.embeds.VideoWithPlayerAndDownload && asset.embeds.VideoWithPlayerAndDownload.url ? asset.embeds.VideoWithPlayerAndDownload.url : "") : "";
						break;
					case "pdf":
						assets[assetIndex].download = asset.embeds ? (asset.embeds.original && asset.embeds.original.url ? asset.embeds.original.url : asset.document_html5_viewer && asset.document_html5_viewer.url ? asset.document_html5_viewer.url : asset.document_viewer_with_download && asset.document_viewer_with_download.url ? asset.document_viewer_with_download.url : asset.document_viewer && asset.document_viewer.url ? asset.document_viewer.url : "") : "";
						break;
					case "image":
					default:
						assets[assetIndex].download = asset.embeds && asset.embeds.original ? asset.embeds.original.url : asset.embeds.OriginalSize ? asset.embeds.OriginalSize.url : "";
				}
				// set assets[index].download to appropriate value from response

				if (assetIndex === assets.length - 1) {
					// at end of asset array

					resolve(assets);
				} else {
					assetIndex++;
					resolve(getLinks(assets, assetIndex));
				}
			} catch (err) {
				reject(JSON.stringify(err));
			}
		} else {
			// this asset is not approved
			// so move on to next
			if (assetIndex === assets.length - 1) {
				resolve(assets);
			} else {
				assetIndex++;
				resolve(getLinks(assets, assetIndex));
			}
		}
	});
};

const notifyUser = (order, approved, assetGroup) => {
	return new Promise(async (resolve, reject) => {
		assetGroup.append(dimmer());
		let time = humanDate(order.time, true, ` ${trans("at")} `);
		let html = `<h3>${trans("Your Gulfstream News Media Request")}</h3>
            <p>${trans("This email is to notify you of an update to your request for Gulfstream media assets.")}</p>
            ${order.note ? `<p>${order.note}</p>` : ""}
            <p><strong>${trans("Your Details")}:</strong> ${order.firstname} ${order.lastname} (${order.city}, ${order.country})<br/>
            <strong>${trans("Order ID")}:</strong> ${order.id}<br/>
            <strong>${trans("Email Address")}:</strong> ${order.email}<br/>
            <strong>${trans("Phone Number")}:</strong> ${order.phone}<br/>
            <strong>${trans("Company name")}:</strong> ${order.company} (<a href="${order.website}" target="_blank">${order.website}</a>)<br/>
            <strong>${trans("Requested")}:</strong> ${time}<br/>
            <strong>${trans("Wanted by")}:</strong> ${humanDate(order.duedate, true, ` ${trans("at")} `)}<br/>
            <strong>${trans("Usage")}:</strong> ${order.use}<br/><br/>
            <strong>${trans("Request details")}:</strong> <br/><br/>
                ${(function () {
					return order.assets
						.map(
							(asset, index) => `<strong>${index + 1}.</strong> ${asset.name}<br/>
                    <strong>${trans("Asset Type")}:</strong> ${trans(asset.type)}<br/>
                    <strong>${trans("Category")}/${trans("Subcategory")}:</strong> ${asset.locator.field.toUpperCase()} > ${asset.locator.value.toUpperCase()}<br/>
                    <strong>${trans("Status")}:</strong> ${trans(asset.status)}<br/>
                    ${asset.note ? `<strong>${trans("Message")}:</strong> ${asset.note}` : ""}<br/><br/>`
						)
						.join("");
				})()}
            </p>
            ${approved ? `<p>${trans("You can visit this link to download approved assets")}: <a href="${location.origin}/${lang}/orders/?id=${order.id}">${trans("Gulfstream Newsroom Orders")}</a></p>` : ""}`;
		const params = {
			noArchive: true, // don't need to keep these in DS email recs
			idempotencyToken: uuid(),
			emailTo: order.email,
			emailReplyTo: "media.requests@gulfstream.com",
			emailBcc: "digital.marketing@gulfstream.com",
			emailFrom: "notifier@gulfstream.aero",
			emailSubject: trans("Your Gulfstream News Media Request has been updated"),
			emailHTML: html,
			emailSource: "newsroom@gulfstream.aero",
			formId: "Newsroom media request: User notification",
			userId: order.email
		};
		try {
			const response = await sendEmail(params);
			resolve(response);
		} catch (err) {
			reject(err);
		}
	});
};
// end notifyUser function
